module.exports = __webpack_public_path__ + "static/img/wzmacniacz.a24d36b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/wzmacniacz.svg
// module id = gRh0
// module chunks = 1